import React, { } from 'react';
import './App.scss';
import { hot } from 'react-hot-loader';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { routesConfig, RouteWithSubRoutes } from './routes';
import NotificationMessageComponent from './components/commons/NotificationMessageComponent';
import { DialogComponent } from './components/commons/DialogComponent';
import packageJson from "../package.json";


class App extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }

  public render() {
    return (
      <Router>
        <div className="main-content">
          <Switch>
            {routesConfig.map((route, i) => (
              <RouteWithSubRoutes key={i} {...route} />
            ))}
          </Switch>

          <NotificationMessageComponent />
          <DialogComponent />
        </div>
      </Router>
    );
  }

  componentDidMount() {
    //clear cache if necessary
    let version = localStorage.getItem('version');
    if (version != packageJson.version) {
      localStorage.setItem('version', packageJson.version);

      if ('caches' in window) {
        caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach(name => {
            caches.delete(name);
          })
        });

        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload();
      }
    }
  };
}

declare let module: object;

export default hot(module)(App);
